const environment = process.env.REACT_APP_ENVIRONMENT;

const baseURL = {
    development: process.env.REACT_APP_DEV_API_URL,
    staging:     process.env.REACT_APP_STAG_API_URL,
    production:  process.env.REACT_APP_PROD_API_URL,
}[environment] || process.env.REACT_APP_DEV_API_URL;

console.log("ENV:", environment);
console.log("BASE URL:", baseURL);

const AdminAuthUrl = `${baseURL}/v1`;

export const URLS = {
    // Auth APIs
    login:              `${AdminAuthUrl}/admin/login`,
    twoFactAuth:        `${AdminAuthUrl}/admin/email2FA`,
    forgotPassword:     `${AdminAuthUrl}/admin/forgot-password`,
    changePassword:     `${AdminAuthUrl}/admin/change-password`,
    updatePassword:     `${AdminAuthUrl}/admin/update-password`,

    // Migration
    dash_MGB_Balance:           `${AdminAuthUrl}/admin/dash_MGB_Balance`,
    dash_MFORGE_Balance:        `${AdminAuthUrl}/admin/dash_MFORGE_Balance`,
    totalBrn_Trfr_cnt_sum:      `${AdminAuthUrl}/admin/totalBrn_Trfr_cnt_sum`,
    getAllMigration:             `${AdminAuthUrl}/admin/getAllMigration`,

    // News
    uploadImage:    `${AdminAuthUrl}/News/uploadImage`,
    postNews:       `${AdminAuthUrl}/News/postNews`,
    getNewss:       `${AdminAuthUrl}/News/getNewss`,
    getNewsbyId:    `${AdminAuthUrl}/News/getNewsbyId`,
    deleteNews:     `${AdminAuthUrl}/News/deleteNews`,
    updateNews:     `${AdminAuthUrl}/News/updateNews`,

    // Referral
    getAllReferral:      `${AdminAuthUrl}/referral/getAllReferral`,
    changeRefStatus:    `${AdminAuthUrl}/referral/changeRefStatus`,
    getSingleReferral:  `${AdminAuthUrl}/referral/getSingleRefDetail`,

    // LeadershipMatrix
    getAllLeadership:        `${AdminAuthUrl}/leadership-matrix`,
    getSingleLeadership:    `${AdminAuthUrl}/leadership-matrix`,

    // Leadership rank
    getLeadershipRank: (page, pageSize) =>
        `${AdminAuthUrl}/affiliate/getAllRankerList?page=${page}&pageSize=${pageSize}`,

    // Staking
    getAllStakes:        `${AdminAuthUrl}/stake/stakes`,
    getStakeRewards:    `${AdminAuthUrl}/stake/stakeRewards`,

    // Referral reward
    getReferalReward:       (page, size)        => `${AdminAuthUrl}/affiliate/referralReward?page=${page}&pageSize=${size}`,
    getRewardTransaction:   (id)                => `${AdminAuthUrl}/affiliate/getRewardTransactions/${id}`,

    // Direct and indirect
    getAllUserForDirectIndirect: (page, size)     => `${AdminAuthUrl}/affiliate/getAllUser?page=${page}&pageSize=${size}`,
    directReferrals:            (page, size)     => `${AdminAuthUrl}/affiliate/directReferrals?page=${page}&pageSize=${size}`,
    indirectReferrals:          (page, size)     => `${AdminAuthUrl}/affiliate/indirectReferrals?page=${page}&pageSize=${size}`,
    getDirectUser:              (id, page, size) => `${AdminAuthUrl}/affiliate/getDirectUser/${id}?page=${page}&pageSize=${size}`,
    getInDirectUser:            (id, page, size) => `${AdminAuthUrl}/affiliate/getIndirectUser/${id}?page=${page}&pageSize=${size}`,
};